module.exports = __webpack_public_path__ + "static/img/USSC.f21faee.f21faee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/USSC.f21faee.jpg
// module id = dUhs
// module chunks = 3